type DraftLocale = "en-US" | "ja-JP" | "ko-KR";

interface DraftUiStrings {
  appBarLabel: string;
  cancelSaveTitle: string;
  cancelSaveBody: (target: string) => string;
  discard: string;
  save: string;
  draftsTab: string;
  draftsHeading: string;
  draftsEmpty: string;
  draftsLoading: string;
  draftsError: string;
  localDraftBadge: string;
  dbDraftBadge: string;
  deleteDraft: string;
  openDraft: string;
  localDraftDescription: string;
  postDraftsHeading: string;
  graphDraftsHeading: string;
  draftSaved: string;
}

const STRINGS: Record<DraftLocale, DraftUiStrings> = {
  "en-US": {
    appBarLabel: "Drafts",
    cancelSaveTitle: "Save draft?",
    cancelSaveBody: (target) => `Save this ${target} as a draft and come back to finish it later.`,
    discard: "Discard",
    save: "Save",
    draftsTab: "Drafts",
    draftsHeading: "Drafts",
    draftsEmpty: "No drafts yet.",
    draftsLoading: "Loading drafts...",
    draftsError: "Failed to load drafts.",
    localDraftBadge: "Local",
    dbDraftBadge: "Saved",
    deleteDraft: "Delete draft",
    openDraft: "Open draft",
    localDraftDescription: "Saved on this browser",
    postDraftsHeading: "Continue a draft",
    graphDraftsHeading: "Graph collection drafts",
    draftSaved: "Draft saved",
  },
  "ja-JP": {
    appBarLabel: "下書き",
    cancelSaveTitle: "下書きを保存しますか？",
    cancelSaveBody: (target) => `この${target}を下書きとして保存し、あとで続きを書けるようにします。`,
    discard: "破棄",
    save: "保存",
    draftsTab: "下書き",
    draftsHeading: "下書き",
    draftsEmpty: "下書きはまだありません。",
    draftsLoading: "下書きを読み込んでいます...",
    draftsError: "下書きを読み込めませんでした。",
    localDraftBadge: "ローカル",
    dbDraftBadge: "保存済み",
    deleteDraft: "下書きを削除",
    openDraft: "下書きを開く",
    localDraftDescription: "このブラウザーに保存済み",
    postDraftsHeading: "下書きから続ける",
    graphDraftsHeading: "グラフコレクションの下書き",
    draftSaved: "下書きを保存しました",
  },
  "ko-KR": {
    appBarLabel: "초안",
    cancelSaveTitle: "초안을 저장할까요?",
    cancelSaveBody: (target) => `이 ${target}을 초안으로 저장하고 나중에 이어서 작성합니다.`,
    discard: "버리기",
    save: "저장",
    draftsTab: "초안",
    draftsHeading: "초안",
    draftsEmpty: "아직 초안이 없습니다.",
    draftsLoading: "초안을 불러오는 중...",
    draftsError: "초안을 불러오지 못했습니다.",
    localDraftBadge: "로컬",
    dbDraftBadge: "저장됨",
    deleteDraft: "초안 삭제",
    openDraft: "초안 열기",
    localDraftDescription: "이 브라우저에 저장됨",
    postDraftsHeading: "초안 이어쓰기",
    graphDraftsHeading: "그래프 컬렉션 초안",
    draftSaved: "초안이 저장되었습니다",
  },
};

export function resolveDraftLocale(): DraftLocale {
  const language = typeof navigator === "undefined" ? "en-US" : navigator.language;
  if (language.startsWith("ja")) {
    return "ja-JP";
  }
  if (language.startsWith("ko")) {
    return "ko-KR";
  }
  return "en-US";
}

export function getDraftUiStrings(locale: DraftLocale = resolveDraftLocale()): DraftUiStrings {
  return STRINGS[locale] || STRINGS["en-US"];
}
